import memoize from '@guestyci/memoize';
import { MomentFormatTypes } from "../utils";
export default memoize(function (format, isEnglish) {
  switch (format) {
    case MomentFormatTypes.Date:
      return isEnglish ? 'll' : 'L';

    case MomentFormatTypes.FullDate:
      return isEnglish ? 'lll' : 'L LT';

    case MomentFormatTypes.MMMM_YYYY:
      return 'MMMM YYYY';

    case MomentFormatTypes.MMM_YYYY:
      return 'MMM YYYY';

    case MomentFormatTypes.ShortDate:
      return 'L';

    default:
      return '';
  }
});